
import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "@/utils/rtkHelper";



export interface users {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
}
export interface userSearch {
  startAt: number;
  pageSize: number;
  sortDesc: boolean;
  filter_groups: any[];
  sorting: any[];
}

export interface userSearchResult {
  items: users[];
  pageSize: number;
  startAt: number;
  sortDesc: boolean;
  total: number;
}



export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: customBaseQuery,
  tagTypes: ["user"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    
    searchUser: builder.query<userSearchResult, userSearch>({
        query: (input) => ({
          url: `/user`,
          method: "POST",
          body: { ...input, export: false },
        }),
        providesTags: ["user"],
      }),
    // exportMessageBox: builder.mutation<Blob, messageSearch>({
    //     query: (input) => ({
    //       url: `/message/search`,
    //       method: "POST",
    //       body: { ...input, export: true },
    //       responseHandler: (response: Response) => response.blob(),
    //     }),
    //   }),
  }),
  
});

export const { 
  useSearchUserQuery,
} = userApi;
